import { Col, Collapse, Row } from "antd";
import React from "react";
import PreviewMedia from "../../biblio/PreviewMedia/PreviewMedia";

interface Props {
  groups: any[];
  loading: boolean;
  isVideo?: boolean;
  emptyText?: string;
  // Custom panel content (e.g. shares list) instead of the media preview
  renderContent?: (group: any) => React.ReactNode;
}

// Participant data (photos / videos / shares) grouped by participant in a collapse
const ParticipantMediaCollapse = ({
  groups,
  loading,
  isVideo = false,
  emptyText = "",
  renderContent,
}: Props) => {
  return (
    <div className="takaful--collapse-profile-container">
      <div className="takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services">
        <Collapse.Panel
          showArrow={false}
          key="label"
          className="takaful--collapse-label-panel"
          header={
            <div className="takaful--header-service-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  span={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    الاسم
                  </p>
                </Col>
                <Col
                  span={12}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم المساهم
                  </p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className="takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests"
        accordion
      >
        {groups.map((group: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={`${group.id}-${index}`}
            showArrow={false}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  align={"middle"}
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    span={12}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {group.name}
                    </span>
                  </Col>
                  <Col
                    span={12}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {group.participant_number || ""}
                    </span>
                  </Col>
                </Row>
              </div>
            }
          >
            {renderContent ? (
              renderContent(group)
            ) : group.items?.length ? (
              <PreviewMedia
                mediaItems={group.items}
                loading={loading}
                itemPerPage={6}
                isVideo={isVideo}
                twoPerRow
              />
            ) : (
              <p className="takaful--no-services">{emptyText}</p>
            )}
          </Collapse.Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default ParticipantMediaCollapse;
